import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';

const MemberShipEmptyResult = () => (
  <Card mt={4}>
    <Box flexDirection="column">
      <Box>{s__('Memberships|No results in this section yet!')}</Box>
    </Box>
  </Card>
);

export default MemberShipEmptyResult;
